/**
 * EveryINC - Init Icons Script
 * Initialize Lucide icons on page load
 */

function refreshIcons(): void {
  if (!window.lucide || typeof window.lucide.createIcons !== 'function') {
    return;
  }

  window.lucide.createIcons({
    attrs: {
      'stroke-width': 1.75
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', refreshIcons);
} else {
  refreshIcons();
}

(window as Window).refreshIcons = refreshIcons;

export { refreshIcons };
